import { Box, IconButton, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import React from "react";

export const SubTitledDealBox = (props) => {
  const { productName, modifiers, onRemoveClick, index } = props;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 10px",
        //maxWidth: { md: "426px", lg: "550px" },
        minWidth: { md: "522px" },
        maxHeight: { md: "144px" },
      }}
    >
      <Box>
        {productName ? (
          <Typography variant="h6" sx={{ alignSelf: "center", width: "100&" }}>
            {productName}
          </Typography>
        ) : null}
        <Typography
          variant="subtitle"
          sx={{ alignSelf: "center", width: "100&" }}
        >
          {modifiers}
        </Typography>
      </Box>
      <IconButton onClick={() => onRemoveClick(index)}>
        <ClearIcon />
      </IconButton>
    </Box>
  );
};
